import { doc, getDoc } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { db } from '../firebase';
import { toast } from 'react-toastify';

const Contact = ({userRef,listing}) => {

 const [landlord,setLandlord] = useState(null);
 const [message,setMessage] = useState("");

 useEffect(()=>{

    const getLandlord = async () => {
        const docRef = await doc(db,"users",userRef);
        const docSnap = await getDoc(docRef);

        if(docSnap.exists()){
                setLandlord(docSnap.data())
        }
        else{

            toast.error("Could not get landlord data.")
        }
    }

    getLandlord();


 },[userRef])

 const onChange = (e) => {

    setMessage(e.target.value)

 }

  return (
    <>{landlord!==null && 
    
    (
        <div className="flex flex-col w-full">
            <p className="">Contact {landlord.name} for the {listing.name.toLowerCase()}</p>
            <div className='mt-3 mb-6'>
                <textarea className="w-full px-4 py-2 text-xl text-gray-700 bg-white
                border border-gray-300 rounded transition duration-150 ease-in-out
                focus:text-gray-700 focus:bg-white focus:border-slate-600" onChange={onChange} name="message" id="message" rows="2" value={message}></textarea>
            </div>

            <a href={`mailto:${landlord.email}?Subject=${listing.name}&body=${message}`}>
                <button type="button" className="px-7 py-3 bg-blue-600 text-white font-medium
                            text-sm uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg
                            w-full text-center transition duration-150 ease-in-out mb-6">
                    Send Message
                </button>
            </a>
        
        </div>
    )
    
    
    }</>
  )
}

export default Contact